import React, { useState } from 'react'
import { googleWallet } from '../../../../api/UserRequest';
import { Button, Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import googleWalletImg from "../../../../assests/images/GoogleWallet.svg"


function AddToGoogleWallet({ cardID, ITxtColor, IColor }) {
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage()
    const error = () => {
        messageApi.open({
            type: 'error',
            content: 'Some thing went wrong, please try after some time.',
        });
    };
    const handleGoogleAddToWallet = async () => {
        try {
            setLoading(true);

            const { data } = await googleWallet(cardID);
            if (data.success) {

                window.location.href = data.walletUrl;
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
            error()
            console.log(err);
        }
    };

    return (
        <div>
            {/* <Button
                style={{
                    color: `${ITxtColor}`,
                    background: `${IColor}`,
                }}
                loading={loading}
                className='p-2 h-12 px-4 rounded-lg shadow-lg flex gap-3 cursor-pointer'
                onClick={() => handleGoogleAddToWallet()}
            >

                <svg width="35" height="29" viewBox="0 0 35 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M34.8184 11.0735H0.489258V5.69011C0.489258 2.76766 3.00882 0.306641 6.0008 0.306641H29.3068C32.2988 0.306641 34.8184 2.76766 34.8184 5.69011V11.0735Z" fill="#34A853" />
                    <path d="M34.8184 16.0402H0.489258V10.3187C0.489258 7.21276 3.00882 4.59717 6.0008 4.59717H29.3068C32.2988 4.59717 34.8184 7.21276 34.8184 10.3187V16.0402Z" fill="#FBBC04" />
                    <path d="M34.8184 20.8083H0.489258V15.0868C0.489258 11.9808 3.00882 9.36523 6.0008 9.36523H29.3068C32.2988 9.36523 34.8184 11.9808 34.8184 15.0868V20.8083Z" fill="#EA4335" />
                    <path d="M0.489258 12.4561L22.278 17.3781C24.7862 17.9934 27.6077 17.3781 29.6454 15.84L34.8184 12.1484V23.6844C34.8184 26.6068 32.3103 28.914 29.332 28.914H5.97562C2.99729 28.914 0.489258 26.6068 0.489258 23.6844V12.4561Z" fill="url(#paint0_linear_1805_3815)" />
                    <defs>
                        <linearGradient id="paint0_linear_1805_3815" x1="16.0177" y1="20.8513" x2="-1.62551" y2="41.5231" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#4285F4" />
                            <stop offset="1" stop-color="#1B74E8" />
                        </linearGradient>
                    </defs>
                </svg>
                <div>
                    <p className='text-xs'>Add to</p>
                    <p className='text-xs font-semibold'>Google Wallet</p>
                </div>

            </Button> */}

            <Spin spinning={loading} indicator={<LoadingOutlined spin />} size="small" >

                <img className='w-[160px] h-[48px] cursor-pointer' onClick={handleGoogleAddToWallet} src={googleWalletImg} alt="" srcset="" />
            </Spin>

            {contextHolder}
        </div>
    )
}

export default AddToGoogleWallet